/** «Козодоев Г. П.», «Козодоев Г. П. и Иванов И. И.», «А, Б и В». */
export function joinNames(names: readonly string[]): string {
    if (names.length < 2) return names[0] ?? '';
    return `${names.slice(0, -1).join(', ')} и ${names.at(-1)}`;
}

/** «Козодоев Г. П. печатает…», «А и Б печатают…»; никто — пустая строка. */
export const typingText = (names: readonly string[]): string =>
    names.length ? `${joinNames(names)} ${names.length > 1 ? 'печатают' : 'печатает'}…` : '';

/** Подряд идущие сообщения одного автора с перерывом не больше этого — одна группа. */
export const CHAT_GROUP_GAP_MS = 5 * 60_000;

/** Что нужно от сообщения чата для группировки ленты. */
export interface IChatGroupMessage {
    /** Своё сообщение: все свои — один автор */
    mine: boolean;
    /** Сторона автора (`user`, `support`) */
    role?: string;
    /** Пользователь автора; без него автор — по имени */
    authorId?: string | null;
    authorName: string;
    /** ISO-время */
    at: string;
}

const authorKey = (message: IChatGroupMessage) =>
    message.mine ? 'mine' : `${message.role ?? ''}:${message.authorId ?? message.authorName}`;

const localDay = (at: string) => {
    const date = new Date(at);
    return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
};

/**
 * `next` продолжает группу `previous` в ленте: тот же автор (свои — одна группа, чужие — по пользователю, без него — по
 * имени), тот же день и перерыв не больше `CHAT_GROUP_GAP_MS`. Над группой — автор, под последним — время.
 */
export const sameChatGroup = (previous: IChatGroupMessage, next: IChatGroupMessage): boolean =>
    authorKey(previous) === authorKey(next) &&
    localDay(previous.at) === localDay(next.at) &&
    Math.abs((Date.parse(next.at) || 0) - (Date.parse(previous.at) || 0)) <= CHAT_GROUP_GAP_MS;
